import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BibliographicResourceService } from '®shared/bibliographic-resource';
import { GoogleBooksModule } from '®shared/google-books';

import { ResourceEditGuard } from './edit/resource-edit.guard';
import { ResourceEditModule } from './edit/resource-edit.module';
import { ListsForResourceModule } from './lists-for-resource/lists-for-resource.module';
import { ResourceRoutingModule } from './resource-routing.module';
import { ResourceSmartComponent } from './resource-smart.component';
import { ResourceEffects } from './resource.effects';
import { ResourceGuard } from './resource.guard';
import { resourceReducer } from './resource.reducer';
import {
  STATE_FEATURE_RESOURCE,
  getInitialResourceState,
} from './resource.state';
import { SharedResourceModule } from './shared-resource.module';

@NgModule({
  imports: [
    ResourceRoutingModule,
    CommonModule,
    EffectsModule.forFeature([ResourceEffects]),
    StoreModule.forFeature(STATE_FEATURE_RESOURCE, resourceReducer, {
      initialState: getInitialResourceState,
    }),
    ListsForResourceModule,
    ResourceEditModule,
    SharedResourceModule,
    GoogleBooksModule,
  ],
  declarations: [ResourceSmartComponent],
  providers: [BibliographicResourceService, ResourceGuard, ResourceEditGuard],
})
export class ResourceModule {}
